export default __webpack_public_path__ + "static/media/pool-finished-sash.538f2fa3.svg";